export default "__VITE_ASSET__B0RzHQQU__";